<template>
  <v-container style="max-width: 100vw; padding: 0;">
    <div class="login-box">
      <div
        style="background-color:#2c599d; color:white; padding:20px; border-radius:15px 15px 0 0; box-shadow:0 0 10px rgba(0,0,0,0.5);"
      >
        <img src="imgs/logo-white.png" width="200px" />
      </div>
      <div
        style="padding: 20px; background: white; display: block; border-radius:15px; margin-top:-15px; box-shadow:0 0 10px rgba(0,0,0,0.5);"
      >
        <div
          style="font-family: Raleway;
                font-size: x-large;
                border-left: 20px solid #6dd0f7;
                padding-left: 20px;
                line-height: 20px;"
        >
          <div style="font-size:small; line-height:14px; margin-top:8px;">
            SISTEM INFORMASI <br />
            OPTIMASI ASSET
          </div>
        </div>
        <br />
        <div
          style="color: gray;
                    margin-top: -15px;
                    margin-bottom: 20px;
                    font-size: small;
                    line-height: 15px;"
        ></div>
        <Input
          label="Username"
          :value.sync="forms.username"
          class="inline"
          left-icon="face"
          width="100%"
        />
        <Input
          label="Password"
          :value.sync="forms.password"
          type="password"
          left-icon="lock"
          width="100%"
        />
        <br />
        <v-btn color="primary" @click="submit" style="width:210px">Login</v-btn>
      </div>
      <!-- <div
        class="logo"
        style="width:144px; height:144px; position:absolute; left:-144px; top:0;"
      >
        <img src="imgs/logo.png" style="width:100px; margin-left:20px;" />
      </div> -->
    </div>
    <div v-if="!isMobile" class="update-desc">
      <div
        style="font-size: xx-large; font-weight: bold; text-shadow: 0 0 5px rgba(0,0,0,0.5);"
      >
        SIPMASSE
      </div>
      <div>
        SISTEM INFORMASI OPTIMASI ASSET
      </div>
      <div>
        DINAS PU BINA MARGA PROVINSI JAWA TENGAH
      </div>
      <div style="font-size: small">
        DIUPDATE AGUSTUS 2023
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({
    forms: {
      username: '',
      password: '',
    },
    tahun: new Date().getFullYear(),
  }),
  mounted() {
    localStorage.setItem('tahun', new Date().getFullYear())
    this.tahun = localStorage.getItem('tahun')

    this.$router.push({ name: 'Home' })
  },
  computed: {
    isMobile() {
      return document.body.clientWidth < document.body.clientHeight
    },
  },
  methods: {
    ...mapActions(['setMenu', 'setUser']),
    getListMenu(menu) {
      let mlist = {}
      menu.forEach(m => {
        if (m.child && m.child.length) {
          if (m.MenuUrl) {
            mlist[m.MenuUrl] = this.getListMenu(m.child)
          } else mlist = Object.assign(mlist, this.getListMenu(m.child))
        } else if (m.MenuUrl) mlist[m.MenuUrl] = m.AccessMode
      })
      return mlist
    },
    async submit() {
      let ret = await this.$api.login(this.forms)
      if (ret.length) {
        this.setUser(ret[0])
        let menu = await this.$api.call('Arch_SelMenu')
        if (menu) {
          this.setMenu(menu)
          localStorage.setItem(
            'menu-access',
            JSON.stringify(this.getListMenu(menu.data))
          )
          if (ret[0].HomeUrl) this.$router.push({ path: ret[0].HomeUrl })
          else this.$router.push({ name: 'Home' })
        }
      }
    },
  },
}
</script>
<style lang="scss">
.login-box {
  position: relative;
  top: 20vh;
  margin: auto;
  left: -25%;
  width: 250px;
}
.update-desc {
  color: white;
  position: absolute;
  left: 40%;
  top: calc(40% + 30px);
}
@media only screen and (max-device-width: 480px) {
  .login-box {
    margin: auto;
    width: 250px;
    left: 0;
  }
  .update-desc {
    display: none;
  }
}
</style>
